// Product review rating skeleton
const ksInitializeProductRatingSkeletons = (root = document) => {
  root.querySelectorAll('.ks-product-rating-skeleton:not([data-ks-initialized])').forEach((skeleton) => {
    skeleton.setAttribute('data-ks-initialized', 'true')

    window.setTimeout(() => {
      if (!skeleton.parentElement?.querySelector('.rapid_reviews_stars_badge')) {
        skeleton.classList.add('ks-product-rating-skeleton-hidden')
      }
    }, 5000)
  })
}

ksInitializeProductRatingSkeletons()

const ksProductRatingObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node instanceof Element) {
        ksInitializeProductRatingSkeletons(node)
      }
    })
  })
})

ksProductRatingObserver.observe(document.documentElement, {
  childList: true,
  subtree: true
})
